import React, { useContext } from "react"
import { LanguageContext } from "../context/LanguageProvider";
import {StatusBar, Box, HStack, IconButton, Text, ArrowBackIcon, Spinner, Select} from "native-base"
import { useNavigate } from "react-router-dom";

function AppBar({title = "PicnicApp", backButton = false, actions = null}) {
  const navigate = useNavigate();
  const {language, setLanguage, i18n} = useContext(LanguageContext)
  const getBack = () =>{
    const mapRegion = localStorage.getItem("mapRegion")
    if (mapRegion)
    {
      navigate(`/index${mapRegion}`)
    }else{
      navigate("/index")
    }
  } 

  const changeLanguage = (langCode) => {
    setLanguage(langCode);
  }
  return <div style={{position:"fixed", width: "100%", zIndex: "10"}}>
    <StatusBar bg="#3700B3" barStyle="light-content"/>
    <Box safeAreaTop bg="darkolivegreen" />
    <HStack bg="darkolivegreen" px="1" py="3" justifyContent="space-between" alignItems="center" w="100%">
      <HStack alignItems="center">
        {backButton ? <IconButton icon={<ArrowBackIcon size="sm" name="menu" color="white" onClick={()=> getBack()}/> } /> :
          null}
        <Text color="white" fontSize="26" fontWeight="normal" marginLeft={backButton ? "0px" : "40px"}>
          {title}
        </Text>
        <Text color="white" fontSize="12" fontWeight="normal" alignSelf="end">
          {`v.${process.env.REACT_APP_VERSION}`}
        </Text>
      </HStack>
      <HStack marginRight="10px">
        {actions && (
          actions.map((action, index) => {
            if (action.link)
            {
              return <div key={index}><a href={ action.link } target="_blank" rel="noopener noreferrer"><IconButton icon={action.icon} /></a></div>
            }else if (action.onClick){
              return <IconButton key={index} icon={action.icon} onPress={() => action.onClick()}/>
            }else if (action.spinner){
              return <Spinner key={index} size="sm" color='white' />
            }
            else{
              return null;
            }
          })
        )
        }
        <div className="lang-select">
          <Select selectedValue={language} 
            accessibilityLabel={i18n.t("select_language")}
            placeholder={i18n.t("select_language")}
            color="white"
            borderWidth="0px"
            _hover={{backgroundColor:"green", cursor: "pointer"}} 
            _focused={{borderColor:"green"}}
            ml="5px" 
            onValueChange={itemValue => changeLanguage(itemValue)}>
              <Select.Item label="EN" value="en" />
              <Select.Item label="ES" value="es" />
              <Select.Item label="CA" value="ca" />
          </Select>
        </div>
      </HStack>
    </HStack>
  </div>;
  }

  export default AppBar;